import React from 'react';
import { Box, Typography } from 'components';
import { FilterBar } from 'components/FilterBar/MarketFilterBar';
import { useMarketFilters } from 'utils';

// This component wraps the FilterBar with the market filter configuration
const MarketFilters = (props) => {
  const { loading, isFilterEnabled, getFilterLabel, marketFilters } = useMarketFilters();

  if (loading) {
    return <Typography>Loading filters...</Typography>;
  }

  // Pass filter configuration to the FilterBar
  return (
    <FilterBar
      {...props}
      filterConfig={{
        isEnabled: isFilterEnabled,
        getLabel: getFilterLabel
      }}
    />
  );
};

export default MarketFilters;
